<template>
  <div>
    <div class="outgoing-detail" v-if="detail != null">
      <div class="card print" id="printed-element">
        <!-- HEADER PERUSAHAAN -->
        <ReceiptHeader type="warehouse" :data="warehouse" />
        <!-- TITLE -->
        <div class="header-container">
          <h4 class="title"><b>LAPORAN MUTASI PER SUPPLIER</b></h4>
        </div>
        <!-- INFO -->
        <div class="info-row">
          <div class="left">
            <p><span>Tipe Mutasi</span>: {{ detail.type }}</p>
            <p><span>Nomor Bon</span>: {{ detail.doc_number }}</p>
            <p>
              <span>Tanggal Bon</span>:
              {{ moment(detail.doc_date).format('DD-MM-YYYY') }}
            </p>
          </div>
        </div>
        <!-- TABLE -->
        <div class="p-grid">
          <div class="p-col-12 p-m-auto">
            <table class="text-center detail-bon">
              <thead>
                <tr>
                  <th rowspan="2">No</th>
                  <th rowspan="2">Kode Barang</th>
                  <th rowspan="2">Nama Barang</th>
                  <th rowspan="2">Sisa Stok</th>
                  <th rowspan="2">Harga Jual</th>
                  <th rowspan="2">Diskon</th>
                  <th :colspan="outlets.length">Distribusi</th>
                  <th rowspan="2">Total Jumlah</th>
                </tr>
                <tr>
                  <th v-for="(item, r) in outlets" :key="r">
                    {{ item.alias }}
                  </th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(an_item, k) in detail.items"
                  :key="k"
                  class="table-data-style"
                >
                  <td>{{ k + 1 }}</td>
                  <td>{{ an_item.item_code }}</td>
                  <td class="text-left">{{ an_item.item_name }}</td>
                  <td>{{ an_item.stock }}</td>
                  <td class="text-right">{{ an_item.price | currency }}</td>
                  <td>{{ an_item.discount }}</td>
                  <td v-for="(item, r) in outlets" :key="r" class="text-center">
                    <span>{{
                      an_item.items[r].qty == 0 ? '' : an_item.items[r].qty
                    }}</span>
                    <br v-if="detail.type == 'SPECIAL_MUTATION'" />
                    <span
                      v-if="detail.type == 'SPECIAL_MUTATION'"
                      class="text-muted small"
                    >
                      {{
                        an_item.items[r].price == 0
                          ? ''
                          : formatPrice(an_item.items[r].price)
                      }}
                    </span>
                  </td>
                  <td class="text-right">{{ an_item.total_qty | number }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReceiptHeader from '@/components/receipt/ReceiptHeader.vue'
var moment = require('moment')

export default {
  data() {
    return {
      moment: moment,
      items: null,
      outlets: [],
      detail: null,
      warehouse: null,
      isDataReady: false
    }
  },

  components: {
    ReceiptHeader
  },

  async mounted() {
    try {
      await Promise.all([this.getWarehouse(), this.getListOutlets()])
      await this.getWarehouseOutbounds()

      // Wait for data to be ready
      this.isDataReady = true

      // Add event listener for afterprint
      window.addEventListener('afterprint', this.handleAfterPrint)

      // Wait for next tick and then print
      this.$nextTick(() => {
        setTimeout(() => {
          window.print()
        }, 1000) // Increased delay to ensure content is rendered
      })
    } catch (error) {
      console.error('Error in mounted:', error)
    }
  },

  beforeDestroy() {
    // Clean up event listener
    window.removeEventListener('afterprint', this.handleAfterPrint)
  },

  methods: {
    handleAfterPrint() {
      // Close the current tab
      window.close()
    },

    async getWarehouse() {
      let warehouse_id = parseInt(this.$route.query.warehouse_id)
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/warehouses`
        )

        if (response.status === 200) {
          this.warehouse = response.data.data.warehouses
          this.warehouse.forEach(warehouse => {
            if (warehouse.id === warehouse_id) {
              this.warehouse = warehouse
            }
          })
        }
      } catch (error) {
        console.error('Error fetching warehouse data:', error)
      }
    },

    async getListOutlets() {
      this.loading = true
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/outlets`
        )
        if (response.status === 200) {
          this.outlets = response.data.data.outlets
        } else {
          console.error('Gagal mendapatkan outlets')
        }
      } catch (error) {
        console.error('Error fetching outlets:', error)
      } finally {
        this.loading = false
      }
    },

    async getWarehouseOutbounds() {
      try {
        const response = await this.$http.get(
          `${process.env.VUE_APP_API_URL}/dashboard/warehouse-outbounds/mutation?doc_number=${this.$route.query.doc_number}`
        )

        if (response.status === 200) {
          this.detail = response.data.data
          for (const item of this.detail.items) {
            item.items = this.outlets.map(outlet => {
              const warehouse_outbound = item.warehouse_outbounds.find(
                warehouse_outbound =>
                  warehouse_outbound &&
                  warehouse_outbound.outlet_id === outlet.id
              )

              // Jika warehouse_outbound tidak ditemukan, set nilai ke 0
              if (!warehouse_outbound) {
                return {
                  outlet_id: outlet.id,
                  price: 0,
                  qty: 0
                }
              }

              return warehouse_outbound
            })
          }
        } else {
          console.error('Gagal mendapatkan detail mutasi')
        }
      } catch (error) {
        console.error('Terjadi kesalahan saat mengambil detail mutasi:', error)
      }
    },

    formatPrice(value) {
      let val = (value / 1).toFixed(0).replace('.', ',')
      return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
    }
  }
}
</script>

<style scoped lang="scss">
table {
  width: 100%;
  border-collapse: collapse;
}

table thead th {
  border: 1px solid #000;
  padding: 8px 6px;
}

.card {
  display: block;
}

.company-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.logo {
  width: 50px;
}

.company-info {
  margin-left: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.header-title {
  font-size: 15px;
  line-height: 1.2;
  font-weight: bold;
  margin-bottom: 2px;
}

.header-subtitle {
  font-size: 13px;
  line-height: 1.2;
  margin-bottom: 1px;
}

.title {
  text-align: center;
  margin-bottom: 15px;
  font-size: 15px;
}

.header-container {
  text-align: center;
  margin-bottom: 15px;
}

.info-row {
  display: flex;
  justify-content: space-between;
  margin-top: 5px;
  margin-bottom: 12px;
}

.left {
  display: flex;
  flex-direction: column;
}

.left p {
  display: flex;
  margin: 2px 0;
}

.left p span {
  display: inline-block;
  width: 150px;
  text-align: left;
}

.border-header {
  border-top: 2px solid #000;
  width: 100%;
  margin: 12px auto;
  justify-content: center;
}

thead tr:nth-child(1) th,
thead tr:nth-child(2) th {
  text-align: center;
  border: 1px solid #000;
  padding: 8px 6px;
  background-color: #f0f0f0;
  font-size: 12px;
  line-height: 1.2;
}

.detail-bon tbody tr {
  td {
    padding: 8px 6px;
    border: 1px solid #000;
    font-size: 12px;
    line-height: 1.3;
    white-space: nowrap;
    max-width: 200px;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

.detail-bon tbody tr:nth-child(odd) {
  background-color: white;
}

.detail-bon tbody tr:nth-child(even) {
  background-color: #f8f8f8;
}

.text-right {
  text-align: right;
}

.text-left {
  text-align: left;
}

.text-center {
  text-align: center;
}

.text-muted {
  color: #6c757d;
}

.small {
  font-size: 0.75rem;
}

.outgoing-detail {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto,
    'Helvetica Neue', Arial, sans-serif;
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  box-sizing: border-box;
  overflow: hidden;
}

// Add specific style for item name column
.detail-bon tbody tr td:nth-child(3) {
  max-width: 250px;
  text-align: left;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

// Add specific style for price columns
.detail-bon tbody tr td.text-right {
  white-space: nowrap;
}

// Add specific style for quantity columns
.detail-bon tbody tr td.text-center {
  white-space: nowrap;
}

@media print {
  .detail-bon {
    border: 1px solid #000;
    border-collapse: collapse;
  }

  .detail-bon th,
  .detail-bon td {
    border: 1px solid #000;
  }

  .detail-bon th {
    padding: 8px 6px;
  }

  .detail-bon td {
    padding: 8px 6px;
  }

  .print table thead {
    display: table-header-group;
  }

  .print:nth-child(1n) {
    page-break-after: always;
  }

  .detail-bon thead tr {
    background-color: #f0f0f0 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  .detail-bon tbody tr:nth-child(even) {
    background-color: #f8f8f8 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }
}
</style>
